<template>
  <div>
    <div v-for="(item,index) in displayItem" :key="index">
      <standard-frame :sub-title="item.title" :sub-content="item.content"/>
    </div>
  </div>
</template>

<script>
  import StandardFrame from './StandardFrame'

  export default {
    name: 'CompanyDetail',
    components: {StandardFrame},
    data() {
      return {
        displayItem:[
          {title:'关于我们',
          content:`
          <p>订单雨专注酒店团队住宿、会务会展等团体业务的网络信息服务平台。通过订单雨系统，采购商随时发布订单需求，完成集合竞价采购，快速采购到理想酒店；酒店通过订单雨房态实时管理更新功能，主动营销、挖掘客户需求，精准定位目标客户。</p>
          <p>订单雨始终坚持为行业赋能，加快团队业务从酒店筛选、预订、结算、客户反馈等，全流程数字化建设改造；使平台成为酒店销售人员日常工作的客房、客户管理和订单管理的数字化分析工具；使采购商、会务会展、企业团队等公司业务快速落地酒店，拓展全行业团队业务的酒店采购能力。</p>
          <p>提升行业网络信息化程度，提高行业供采效率，打造真正的行业信息互联互通的产业互联网数字平台；破除行业信息壁垒，减轻酒店团队业务营销成本，提升客户体验。你的选择，就是我们坚持的动力!</p>          
          `,
          contentOld:` <p>不同于国内众多其它平台的中介抽佣模式，我们是通过移动互联网技术和独创交易撮合机制，为中国酒店业搭建一个完全杜绝第三方中介分销商，面向酒店行业客户（采购商、会展公司等）的开放、透明、中立的B2B在线直销和交易撮合平台。</p>
                                          <p>订单雨不介入或影响任何平台交易的达成，我们将专注于通过移动互联网技术和在线交易机制的创新，帮助解决传统酒店产品线下B2B交易的种种问题和弊端，提高交易效率、减少交易环节及降低交易成本。</p>`},
          // {title:'我们想做什么',content:`<p>互联网+时代给传统酒店业带来了新的机遇，订单雨的使命是“将酒店营销自主权还给酒店“帮助中国酒店业真正进入在线直销时代。</p>`}
        ]
      }
    }
  }
</script>
